import { Router } from '@angular/router';
import { AccountService } from '../../core/services/account.service';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { ShellActions } from '../../core/actions';
import * as i0 from "@angular/core";
import * as i1 from "../../core/services/account.service";
import * as i2 from "@angular/router";
import * as i3 from "@ngrx/store";
var AuthenticatedGuard = /** @class */ (function () {
    function AuthenticatedGuard(accountService, router, store) {
        this.accountService = accountService;
        this.router = router;
        this.store = store;
    }
    AuthenticatedGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        var url = state.url;
        this.store.dispatch(new ShellActions.SetProcessing(true));
        return this.accountService.loggedIn().pipe(map(function (success) {
            if (!success) {
                var returnUrl = encodeURIComponent(baseUrl + "#" + url);
                window.location.href = baseUrl + "Account/Login?returnUrl=" + returnUrl;
            }
            _this.store.dispatch(new ShellActions.GetLoggedInStatusSuccess());
            return success;
        }));
    };
    AuthenticatedGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthenticatedGuard_Factory() { return new AuthenticatedGuard(i0.ɵɵinject(i1.AccountService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.Store)); }, token: AuthenticatedGuard, providedIn: "root" });
    return AuthenticatedGuard;
}());
export { AuthenticatedGuard };
var UnauthenticatedGuard = /** @class */ (function () {
    function UnauthenticatedGuard(accountService, router, store) {
        this.accountService = accountService;
        this.router = router;
        this.store = store;
    }
    UnauthenticatedGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        if (next.routeConfig.path == "profiles") { //currently unnecessary since this guard is only used on profiles route
            var regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
            var baseProfileurl = "/profiles/";
            var urlLength = state.url.length;
            if (next.children[0].routeConfig.children[0].path == ":profileId") {
                var profileId = state.url.substring(baseProfileurl.length, urlLength).replace('/', '');
                if (profileId.length > 0 && !regexExp.test(profileId)) { //is profile id not in correct guid format
                    /*trying to get 404 page to load gave me a http error and had a spinner, so I'm just redirecting to profiles index */
                    setTimeout(function () { return _this.router.navigateByUrl('profiles' /*, { skipLocationChange: true }*/); });
                }
            }
        }
        return true;
    };
    UnauthenticatedGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UnauthenticatedGuard_Factory() { return new UnauthenticatedGuard(i0.ɵɵinject(i1.AccountService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.Store)); }, token: UnauthenticatedGuard, providedIn: "root" });
    return UnauthenticatedGuard;
}());
export { UnauthenticatedGuard };
